import { omitBy } from 'lodash';

export const diff = (current, base) => omitBy(current, (value, key) => base[key] === value);

/**
 * Merge changes into an existing query string, returning the new one.
 *
 * Patching rather than rebuilding, so a page that puts several pieces of state in
 * the URL cannot drop one by forgetting to re-append it. Null, undefined and ''
 * remove a key — that is how state goes back to its default rather than being
 * pinned to an empty value.
 */
export const patchSearch = (search, patch) => {
  const params = new URLSearchParams(search);
  Object.entries(patch).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') {
      params.delete(key);
    } else {
      params.set(key, value);
    }
  });
  return params.toString();
};
